import { useEffect, useState } from "react";

import { Outlet } from "react-router-dom";
import classnames from "classnames";

const BlankLayout = () => {

    // ** States
    const [isMounted, setIsMounted] = useState(false);

    // ** Hooks
    useEffect(() => {
        setIsMounted(true);
        // return () => setIsMounted(false);
    }, []);

    if (!isMounted) {
        return null;
    }

    return (
        <div
            className={classnames("blank-page")}>
            <div className='app-content content'>
                <div className='content-wrapper'>
                    <div className='content-body'>
                        {/* {!["/superadmin", "/third-party"].includes(window.location.pathname) && <IntlDropdown className="position-absolute end-0 mx-3 my-2 border p-75 rounded"/>} */}
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlankLayout;
